export enum CurrencyType {
	PoundSterling = '£',
	USDollar = '$',
}
